export enum ScheduleStatus {
  SCHEDULED = 1,
  SENT = 2,
  FAILED = 3,
}
